module.exports = "/static/media/dot-texture.4f3b91c5.svg";